export default {
  title: "Verificar correo electrónico",
  verifying: {
    title: "Verificando su correo electrónico",
    subtitle: "Por favor espere mientras verificamos su dirección de correo electrónico...",
  },
  sending: {
    title: "Enviando correo de verificación",
    subtitle: "Por favor espere mientras enviamos el correo de verificación...",
  },
  sent: {
    title: "Correo de verificación enviado",
    confirmationMessage: {
      beforeEmail: "Hemos enviado un enlace de confirmación a ",
      afterEmail: "",
    },
    instruction:
      "Por favor revise su bandeja de entrada y haga clic en el enlace para activar su cuenta",
    troubleMessage:
      '¿No recibió el correo? Revise su carpeta de spam o haga clic en "Reenviar" abajo',
    limitNote: "Nota: Puede reenviar el correo de verificación hasta 3 veces por día",
  },
  resent: {
    title: "Correo de verificación reenviado",
    confirmationMessage: {
      beforeEmail: "Hemos reenviado el enlace de confirmación a ",
      afterEmail: "",
    },
    instruction:
      "Por favor revise su bandeja de entrada y haga clic en el enlace para activar su cuenta",
    troubleMessage: "Si aún no lo recibe, revise spam/basura o intente nuevamente más tarde",
    limitNote: "Nota: Puede reenviar el correo de verificación hasta 3 veces por día",
  },
  success: {
    title: "Correo electrónico verificado con éxito",
    subtitle: "Su correo electrónico ha sido verificado. Ahora puede iniciar sesión en su cuenta.",
    button: "Ir a iniciar sesión",
    autoRedirectMessage: "Redirigiendo al panel de control en {seconds} segundos...",
  },
  error: {
    title: "Error en la verificación del correo electrónico",
    subtitle: "Ocurrió un error durante la verificación. Por favor intente nuevamente más tarde.",
  },
  resending: "Reenviando...",
  resendAvailableIn: "Reenvío disponible en {seconds}s",
  resendVerificationEmail: "Reenviar correo de verificación",
  verificationFailed: "Error en la verificación del correo electrónico",
  verificationError: "Ocurrió un error durante la verificación del correo electrónico",
  pleaseWait: "Por favor espere {seconds} segundos antes de reenviar",
  dailyLimitReached: "Límite diario de reenvío alcanzado. Intente mañana.",
  resentSuccess: "Correo de verificación reenviado con éxito",
  resendFailed: "Error al reenviar el correo de verificación",
  invalidRequest: "Solicitud inválida",
  remainingAttempts: "Tiene {count} intentos restantes hoy",
};
